import React, { useContext } from "react";
import ColorPickerUI from "../../common/ColorPickerUI";
import TextField from "../../common/TextField";
import MenuItem from "../../common/Menu";
import { Store } from "../../state/state";
import Title from "../../common/Title";
import { useObserver } from "mobx-react";

function SettingText({ select }) {
  const store = useContext(Store);
  return useObserver(() => (
    <div>
      <Title>الخط</Title>
      <TextField type="text" label="المحتوى" />

      <ColorPickerUI
        id={"text-" + select}
        label={"اللون"}
        color={store.theme.header[select].color}
        onChange={(color) => (store.theme.header[select].color = color.hex)}
      />
      <TextField
        type="number"
        label="حجم الخط"
        value={store.theme.header[select].fontSize}
        onChangeText={(t) => (store.theme.header[select].fontSize = t)}
      />

      <MenuItem
        FontData
        label={"نوع الخط"}
        value={store.theme.header[select].fontFamily}
        onSelect={(t) => (store.theme.header[select].fontFamily = t)}
      />

      <MenuItem
        data={[
          { value: "bold", key: "غامق" },
          { value: "normal", key: "عادي" },
          { value: "italic", key: "مائل" },
        ]}
        label={"شكل الخط"}
        value={store.theme.header[select].fontStyle}
        onSelect={(t) => (store.theme.header[select].fontStyle = t)}
      />
    </div>
  ));
}

export default SettingText;
